import { render, staticRenderFns } from "./DiscountCreator.vue?vue&type=template&id=5cde7b44&scoped=true&lang=pug&"
import script from "./DiscountCreator.vue?vue&type=script&lang=js&"
export * from "./DiscountCreator.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCreator.vue?vue&type=style&index=0&id=5cde7b44&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cde7b44",
  null
  
)

export default component.exports